module.exports = __webpack_public_path__ + "img/lou.089f3e41.png";